export default __webpack_public_path__ + "static/media/heightmap3d.899d2f9d.png";